import Reveal from 'stimulus-reveal-controller'

export default class extends Reveal {
  static targets = ["trigger", "item"]
  // Only used when conditionalToggle is called.
  static values = { match: String }

  conditionalToggle(event) {
    // If no match value is provided, throw an error.
    if (!this.hasMatchValue) {
      throw new Error("The 'matchValue' must be provided when using conditionalToggle")
    }

    if (this.triggerTarget.value === this.matchValue) {
      this.show()  // Inherited: removes the hidden class from the target item(s)
    } else {
      this.hide()  // Inherited: adds the hidden class to the target item(s)
    }
  }
}